export default {
  idc_invoicing: false,
  comments: null,
  articles: []
};
